<template>
  <b-modal
    :id="'ManageCreditCardModal' + apparatusId"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    no-fade
    no-stacking
    centered
  >
    <template #modal-header>
      <div class="pt-3">
        <h2 class="font-weight-normal" data-test-hook="mobile-subscription-manage-credit-card-modal-header">
          <div>
            <i
              class="far fa-exclamation-triangle colorOrange mr-1"
              data-test-hook="mobile-subscription-manage-credit-card-modal-header-icon"
            />
            {{ $t('xYourAccountNeedsAttentionHeader') }}
          </div>
        </h2>
      </div>
      <div class="float-right">
        <b-button
          class="btn-icon-button--gray"
          variant="icon-button"
          @click="closeModal()"
          data-test-hook="x-button-feedback-modal"
        >
          <i class="fas fa-times" />
        </b-button>
      </div>
    </template>
    <div>
      <p>
        {{ $t('xUpdateYourPaymentMethodGeneral') }}
        {{ getModalTextDate() }}
        {{ $t('xYourPlanWillBeCanceled') }}
      </p>
      <p>{{ getModalBodyText() }}</p>
    </div>
    <template #modal-footer>
      <b-button
        v-if="!isYellowstone"
        variant="secondary"
        @click="
          $router.push({
            path: `/details/${apparatusId}/deviceDetails`
          })
        "
      >
        {{ viewDetailsButtonLabel }}
      </b-button>
      <b-button
        v-if="isWebSubscription"
        variant="primary"
        @click="goToUpgradeModal()"
        :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
      >
        {{ $t('xUpdatePaymentMethod') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'
import { billingMaintenanceFeatureFlagEnabled, displayShortDate } from '../../utils/mixins'

export default {
  props: ['subscriptionDetails', 'apparatusId', 'isWebSubscription', 'isYellowstone', 'apparatusType'],
  methods: {
    closeModal() {
      this.$bvModal.hide('ManageCreditCardModal' + this.apparatusId)
    },
    goToUpgradeModal() {
      this.$emit('switchModal')
    },
    getModalBodyText() {
      if (this.isWebSubscription) {
        return ''
      }
      if (
        this.subscriptionDetails?.subscriptions?.some(
          sub => sub.store === Constants.AppleSubscriptionStore && sub.status !== Constants.SubscriptionDetailCanceled
        )
      ) {
        return this.$t('xUpdateYourPaymentMethodIOS')
      } else {
        return this.$t('xUpdateYourPaymentMethodAndroid')
      }
    },
    getModalTextDate() {
      const gracePeriodEndDate = this.subscriptionDetails?.subscriptions?.find(
        x => x.reason === Constants.SubscriptionDetailsReasonGracePeriodStarted
      )?.gracePeriodEndDate

      if (gracePeriodEndDate) {
        return displayShortDate(gracePeriodEndDate, true)
      }

      // check legacy subscription
      const dunningEndDate = this.subscriptionDetails?.legacyBillingProducts?.products?.find(
        product => product.apparatusId === this.apparatusId && product.gracePeriodEndDate
      )?.gracePeriodEndDate

      if (dunningEndDate) {
        return displayShortDate(dunningEndDate, true)
      }

      return ''
    }
  },
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    }),
    viewDetailsButtonLabel() {
      return this.apparatusType === Constants.FuelTankApparatusType
        ? this.$t('xViewTankDetailsLabel')
        : this.$t('xViewGenDetails')
    }
  }
}
</script>
